<template>
	<transition name="modal">
		<div class="modal modal-mask" style="display: block">
			<hamburger @hamburger="hamburgerClicked"></hamburger>
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header" v-on:click="categoryClicked">
						<p>For Your Consideration</p>
						<img src="https://res.cloudinary.com/dwmmozjrb/image/upload/v1627839187/three-bb/threebb_logo.png" class="title" alt="Three Bill">
					</div>
					<div class="modal-body">
						<slot name="body">
							<categories data="test" v-if="modaltype == 'menu'" :categories="categories" @clicked="categoryClicked"></categories>
						</slot>
					</div>
					<div class="modal-footer">
						<slot name="footer"></slot>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import Hamburger from './Hamburger';
import Categories from './Categories';

export default {
	name: 'modal',
	props: {
		modaltype: {
			required: false,
			type: String
		},
		categories: {
			required: true,
			type: Object
		}
	},
	data() {
		return {
			showModal: false
		}
	},
	components: {
		Categories,
		Hamburger
	},
	methods: {
		categoryClicked(value) {
			console.log(value + ' was clicked in Modal');
			if(typeof(value) !== 'string') { value = ''; }
			this.$emit('clicked', value);
		},
		hamburgerClicked: function() {
			console.log('hamburger passing through modal');
			this.$emit('hamburger');
		}
	}
}
</script>


// WEBPACK FOOTER //
// Modal.vue?0a6e74e8